import { useMemo } from 'react';
import { useJiraUserBoardNavigationResource } from '@atlassian/jira-navigation-apps-sidebar-common/src/controllers/common/jsw-user-board-navigation-resource/index.tsx';
import type { UseFeaturesReturn } from './types.tsx';

export const useFeatures = (): UseFeaturesReturn => {
	const { data, loading, error } = useJiraUserBoardNavigationResource();
	const extractedData = useMemo(
		() =>
			data
				? {
						hasBacklog: data.hasBacklog,
						hasBoard: data.hasBoard,
						hasReports: data.hasReports,
					}
				: null,

		[data],
	);

	return { data: extractedData, loading, error };
};
